<template>
  <div class="AmazonOrders full-height">
    <table-con canReturn="1">
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="$t('amazon.amazon10')"></editBreadcrumb>
      </div>
      <div slot="search">
        <div class="demo-form new-box">
          <div class="demo-form-item">
            <span class="form-item-label">{{ $t('goods.goods2' || '商品名称') }}:</span>
            <el-input
              v-model="queryInfo.productName"
              :placeholder="$t('orderList.orderList3')"
              clearable
              size="small"
            />
          </div>
          <div class="demo-form-item">
            <span class="form-item-label">ASIN:</span>
            <el-input
              v-model="queryInfo.asin"
              :placeholder="$t('orderList.orderList3')"
              clearable
              size="small"
            />
          </div>
          <div class="demo-form-item">
            <span class="form-item-label">SKU:</span>
            <el-input
              v-model="queryInfo.sellerSku"
              :placeholder="$t('orderList.orderList3')"
              clearable
              size="small"
            />
          </div>
          <div class="demo-form-item">
            <span class="form-item-label">{{ $t('amazon.amazon15' || '订单日期') }}:</span>
            <el-date-picker
              v-model="queryInfo.time"
              type="daterange"
              range-separator="-"
              size="small"
              :start-placeholder="$t('datePicker.start')"
              :end-placeholder="$t('datePicker.end')"
            >
            </el-date-picker>
          </div>
          <div class="demo-form-btn">
            <el-button
              type="primary"
              size="small"
              class="search-btn btn-blue"
              @click="handleOrder"
            >{{ $t('amazon.amazon25' || '手动同步') }}</el-button>
            <el-button
              type="primary"
              size="small"
              class="search-btn btn-blue"
              @click="getrecordList"
            >{{ $t('common.search') }}</el-button>
            <el-button
              type="primary"
              size="small"
              class="search-btn btn-gray"
              @click="handleClear"
            >{{ $t('common.reset') }}</el-button>
          </div>
        </div>
      </div>
      <div slot="table" class="lx-table-wrapper lx-flex-grow-1 lx-hidden lx-relative amazon-table-wrap">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="recordList"
          highlight-current-row
          border
          height="100%"
          style="width: 100%;height: 100%"
          :row-style="{height: '40px'}"
        >
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column min-width="150" prop="purchaseDate" align="center" :label="$t('amazon.amazon15' || '订单日期')">
          </el-table-column>
          <el-table-column prop="typeDetail" align="center" :label="$t('OrderDetail.OrderDetail41' || '订单详情')" min-width="250">
            <template v-slot="{row}">
              <div style="text-align: left;">
                <div v-if="row.buyerEmail">{{$t('amazon.amazon16' || '买家账号')}}: {{row.buyerEmail}}</div>
                <div v-if="row.fulfillmentChannel">{{$t('amazon.amazon17' || '配送渠道')}}: {{row.fulfillmentChannel}}</div>
                <div v-if="row.salesChannel">{{$t('amazon.amazon18' || '销售渠道')}}: {{row.salesChannel}}</div>
                <div v-if="row.sellerOrderId">{{$t('amazon.amazon19' || '卖家订单编号')}}: {{row.sellerOrderId}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120" prop="typeDetail" align="center" :label="$t('feedback.feedback9' || '图片')">
            <template v-slot="{row}">
              <div class="amazon-order-img-wrap">
                <div v-for="(item,index) in row.orderItemsList" :key="index">
                  <img v-if="item.image && item.image.length > 0" @click="imgclick(item.image, true)" :src="item.image" alt="" class="list-image" />
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="220" prop="typeDetail" align="center" :label="$t('goods.goods2' || '商品名称')">
            <template v-slot="{row}">
              <el-tooltip v-if="row.orderItemsList && row.orderItemsList.length" popper-class="tooltip-haswidth" effect="light" placement="top-start" transition="">
                <div slot="content">
                  <div v-for="(item, index) in row.orderItemsList" :key="index">
                    {{ item.title }}
                  </div>
                </div>
                <div class="text-row-2">
                  {{ row.orderItemsList[0].title }}
                </div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column prop="orderType" align="center" :label="$t('fba.orderType' || '订单类型')" min-width="120">
            <template v-slot="{row}">
              {{ddType[row.orderType]}}
            </template>
          </el-table-column>
          <el-table-column prop="orderStatus" align="center" :label="$t('fba.orderState' || '订单状态')" min-width="120">
            <template v-slot="{row}">
              {{ddStatus[row.orderStatus]}}
            </template>
          </el-table-column>

<!--            <el-table-column prop="balance" align="center" :label="$t('handle')">
            <template v-slot="{row}">
              <el-button class="search-btn btn-blue" @click="handleTK(row)">{{ $t('capitalflow.capitalflow13' || '退款') }}</el-button>
              <el-button class="search-btn btn-blue" @click="handleFH(row)">{{ $t('BuddleOrder.BuddleOrder6' || '发货') }}</el-button>
            </template>
          </el-table-column>-->
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :pager-count="5"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </table-con>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
    </el-dialog>
  </div>
</template>
<script>
import editBreadcrumb from "@/views/layout/components/editBreadCrumb.vue";
import tableCon from '@/views/tableContainer';
export default {
  name: "AmazonGoods",
  components: { editBreadcrumb, tableCon },
  data(){
    return {
      queryInfo: {
        sellingPartnerId:'',
        productName: '',
        asin: '',
        sellerSku: '',
        purchaseDateStart: '',
        purchaseDateEnd: '',
        time: [],
        pageSize: 10,
        pageNum: 1,
      },
      recordList: [{id: 1}],
      total: 0,
      ddType: {
        StandardOrder: this.$t('amazon.amazon27'),
        LongLeadTimeOrder: this.$t('amazon.amazon28'),
        Preorder: this.$t('amazon.amazon29'),
        BackOrder: this.$t('amazon.amazon30'),
        SourcingOnDemandOrder: this.$t('amazon.amazon31'),
      },
      ddStatus: {
        Pending: this.$t('amazon.amazon32'),
        Unshipped: this.$t('amazon.amazon33'),
        PartiallyShipped: this.$t('amazon.amazon34'),
        Shipped: this.$t('amazon.amazon35'),
        Canceled: this.$t('amazon.amazon36'),
        Unfulfillable: this.$t('amazon.amazon37'),
        InvoiceUnconfirmed: this.$t('amazon.amazon38'),
        PendingAvailability: this.$t('amazon.amazon39'),
        Delivered: this.$t('amazon.amazon40'),
      },
      visible: false,
      imgurl: '',
    }
  },
  watch: {
    'queryInfo.time': function (val) {
      if (val && val.length === 2) {
        this.queryInfo.purchaseDateStart = this.getTimestamp(val[0], true)
        this.queryInfo.purchaseDateEnd = this.getTimestamp(val[1], false)
        // this.queryInfo.purchaseDateStart = this.formatDate(val[0], true)
        // this.queryInfo.purchaseDateEnd = this.formatDate(val[1], false)
      } else {
        this.queryInfo.purchaseDateStart = ''
        this.queryInfo.purchaseDateEnd = ''
      }
    }
  },
  methods:{
    imgclick (url) {
      this.visible = true
      this.imgurl = url
    },
    getTimestamp(date, isStart) {
      const d = new Date(date)
      if (isStart) {
        d.setHours(0, 0, 0, 0)
      } else {
        d.setHours(23, 59, 59, 999)
      }
      // 返回 10 位时间戳（单位：秒）
      return Math.floor(d.getTime() / 1000)
    },
    // 时间格式化函数
    formatDate(date, isStart) {
      const d = new Date(date)
      if (isStart) {
        d.setHours(0, 0, 0, 0)
      } else {
        d.setHours(23, 59, 59, 999)
      }

      const pad = n => (n < 10 ? '0' + n : n)

      const yyyy = d.getFullYear()
      const MM = pad(d.getMonth() + 1)
      const dd = pad(d.getDate())
      const hh = pad(d.getHours())
      const mm = pad(d.getMinutes())
      const ss = pad(d.getSeconds())

      return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`
    },
    // 手动同步订单
    async handleOrder(){
      const res = await this.$http.get('aws/amazonOrder/orderSync',{params: {sellingPartnerId:this.queryInfo.sellingPartnerId}});
      if(res.data.code === 200){
        this.$message({
          message: this.$t('amazon.amazon26' || '数据正在加载中，请稍等。'),
          type: 'success'
        });
        await this.getrecordList()
      }
    },
    // 退款
    handleTK (row) {
      console.log(row)
    },
    // 发货
    handleFH (row) {
      console.log(row)
    },
    async getrecordList(){
      let params = {
        ...this.queryInfo,
      }
      if(params.time){
        delete params.time
      }
      console.log(params);
      const { data: res } = await this.$http.get('aws/amazonOrder/orderPage', { params });
      console.log(res);
      this.recordList = res.rows;
      this.total = res.total;
    },
    handleClear(){
      this.queryInfo.productName = '';
      this.queryInfo.asin = '';
      this.queryInfo.sellerSku = '';
      this.queryInfo.purchaseDateStart = '';
      this.queryInfo.purchaseDateEnd = '';
      this.queryInfo.time = [];

      this.getrecordList()
    },
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize;
      this.getrecordList();
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pageNum = newPage;
      this.getrecordList();
    },
  },
  created () {
    this.queryInfo.sellingPartnerId = this.$route.query.sellingPartnerId;
    this.getrecordList();
  },
}
</script>
<style scoped lang="less">
.AmazonOrders {
  .search-btn {
    height: 26px!important;
    line-height: 26px!important;
    padding: 0 12px !important;
    font-size: 11px!important;
    margin-right: 0 !important;
    ::v-deep span{
      font-size: 11px!important;
    }
  }
}
.demo-form{
  display: flex;
  flex-wrap: wrap;
  .demo-form-item {
    display: flex;
    align-items: center;
    width: calc(20% - 10px);
    margin-right: 10px;
    // margin-bottom: 10px;
    .form-item-label {
      white-space: nowrap;
      margin-right: 4px;
      font-size: 12px;
    }
  }
  .demo-form-item:nth-last-child(1 of .demo-form-item) {
    margin-right: 0;
    width: 20%;
  }
  .demo-form-btn {
    flex: 1;
    // width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
.order-end {
  display: flex;
  justify-content: flex-end;
}
.amazon-table-wrap {
  display: flex;
  flex-direction: column;
}
.amazon-order-img-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .demo-form {
    .demo-form-item {
      margin-right: 0;
      margin-bottom: 10px;
      .form-item-label {
        width: 80px;
        text-align: right;
      }
    }
    .demo-form-item:nth-last-child(1 of .demo-form-item) {
      width: 100%;
    }
    .demo-form-item, .demo-form-btn {
      width: 100%
    }
  }
}
</style>
<style>
.tooltip-haswidth {
  max-width: 260px;
}
</style>
